import React from 'react';

const LiftErase = () => {
    return (
      <React.Fragment>
        {/* <LiftErase /> */}
        <div className="btn__base r4c1">
          <div className="btn">
            <div className="numbox">
              <div className="num">
                <div className="arrow">
                  <div className="arrow-top"></div>
                  <div className="arrow-mid"></div>
                  <div className="arrow-btm"></div>
                </div>
              </div>
              <div className="btm">1-4</div>
            </div>
          </div>
        </div>
        {/* End LiftErase */}
      </React.Fragment>
    );
  };

export default LiftErase;